import sessionData from "./data.js";

/**
 * @description Get session
 * @param {string} sessionId - The sessionId of the session to update
 * @returns {object|null} - Returns session object if found, otherwise null
 */

function get(sessionId: string) {
	return sessionData.get(sessionId) ?? null;
}

export { get };

export default get;
